export default function logoutForm() {
  const logout = document.querySelectorAll("[data-logout]");

  if (!logout) return;

  // Send form via AJAX
  const sendForm = (u) => {
    // Form data
    let data = new FormData();
    data.append("action", "userLogOut");
    data.append("user_id", u.dataset.userId);

    // Send request
    fetch(BAMBOO.ajaxUrl, {
      method: "POST",
      credentials: "same-origin",
      body: data,
    })
      // .then((response) => response.json())
      .then((data) => {
        // console.log(data);
        location.reload();
      })
      // Fetch error
      .catch((err) => {
        // console.log(err);
      });
  };

  logout.forEach((l) => l.addEventListener("click", (e) => sendForm(l)));
}
